import SVG from "../../../Components/SVG";
import { useRef } from "react";

export default function InputSelect({
  options = [],
  defaultValue,
  id,
  name,
  value,
  onChange,
}) {
  const selectRef = useRef(null);

  const handleContainerClick = (e) => {
    if (selectRef.current && e.target === selectRef.current) return;
    if (selectRef.current) {
      selectRef.current.focus();
      selectRef.current.click();
    }
  };

  const handleChange = (e) => {
    if (onChange) onChange(e.target.value);
  };

  return (
    <div
      className="relative w-full inline-flex items-center rounded-lg text-sm gap-2.5 bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus-within:ring-1 hocus-within:ring-zi-border-dark"
      onClick={handleContainerClick}
    >
      <select
        ref={selectRef}
        id={id}
        name={name}
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        className="w-full bg-transparent outline-none appearance-none border-none py-1.5 px-2.5 cursor-pointer"
      >
        {options.map((opt, index) => (
          <option
            key={index}
            value={opt.value ?? opt}
            className="text-zi-text-light"
          >
            {opt.label ?? opt}
          </option>
        ))}
      </select>

      {/* Custom select arrow icon (replaces browser default) */}
      <div className="pointer-events-none absolute left-3 flex items-center">
        <SVG
          name="select"
          classname="size-3 stroke-zi-text-light dark:stroke-zi-text-dark"
        />
      </div>
    </div>
  );
}
